/* eslint-disable arrow-parens */
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import {
  ADD_MERCHANT_LOGO_GQL,
  CREATE_CUSTOM_MERCHANT_GQL,
} from '@/graphql/queries.gql';
import {
  GET_MAIN_MERCHANT_GQL,
  UPDATE_CUSTOM_MERCHANT_GQL,
  UPDATE_MERCHANTS_PARENT_GQL,
  GET_UNMAPPED_MERCHANT,
  UPDATE_MERCHANT_TAG_GQL,
  GET_MAPPED_MERCHANT,
  UPDATE_QUICKBOOK_STATUS_FOR_MERCHANT_GQL,
  GET_MERCHANT_QBSTATUS_TRANSACTIONS,
  SET_AUTO_MAP_MERCHANT,
  REMOVE_AUTO_MAP_MERCHANT,
  SET_MERCHANT_CARD,
  REMOVE_MERCHANT_CARD,
  GET_CARD_MERCHANT,
} from '@/graphql/merchants.gql';

export default {
  namespaced: true,
  state: {
    merchantLogo: [],
    createMerchants: [],
    userFrndlyMerchants: [],
    updateMerchantDetails: [],
    unmappedMerchant: [],
    mappedMerchants: [],
    updateMerchantParentDetails: [],
    getNewMerchant: [],
    qbStatusUpdateForExpense: [],
    getMappedMerchants: [],
    autoMapRules: [],
    removedMapRules: null,
    addMerchantCard: null,
    removeMerchantCard: null,
    cardsMerchant: null,
  },
  mutations: {
    SET_CARD_MERCHANT(state, payload) {
      state.cardsMerchant = payload;
    },
    SET_MERCHANT_LOGO(state, payload) {
      state.merchantLogo = payload;
      const userfrndlymerchant = state.userFrndlyMerchants.find((user) => user.id === payload.updateMerchant.id);
      userfrndlymerchant.logo = payload.updateMerchant.logo;
    },
    SET_NEW_MERCHANT(state, payload) {
      const newMerchant = {};
      newMerchant.id = payload.createMerchant.id;
      newMerchant.name = payload.createMerchant.name;
      newMerchant.logo = payload.createMerchant.logo;
      newMerchant.recordStatus = 1;
      state.userFrndlyMerchants.push(newMerchant);
      state.getNewMerchant = payload;
    },
    GET_USER_FRIENDLY_MERCHANTS(state, payload) {
      state.userFrndlyMerchants = payload;
    },
    SET_MAPPED_MERCHANT(state, payload) {
      state.mappedMerchants = payload;
    },
    SET_CREATED_MERCHANT(state, payload) {
      state.createMerchants = payload;
      const mappingData = {};
      mappingData.parentID = payload.createMerchant.parent;
      mappingData.merchantName = payload.createMerchant.name;
      state.userFrndlyMerchants.forEach((umt) => {
        const mtData = {};
        mtData.id = umt.id;
        if (umt.id === payload.createMerchant.parent) {
          umt.mapped.push(mappingData);
        }
      });
    },
    SET_UNMAPPED_MERCHANT(state, payload) {
      state.unmappedMerchant = payload;
    },
    SET_MERCHANT_PARENT(state, payload) {
      state.updateMerchantParentDetails = payload;
      if (payload.updateMerchantParent.recordStatus === 0) {

        const mappingData = {};
        mappingData.parentID = payload.updateMerchantParent.parents;
        mappingData.merchantName = payload.updateMerchantParent.name;
        state.userFrndlyMerchants.forEach((umt) => {
          const mtData = {};
          mtData.id = umt.id;
          umt.mapped.forEach((mapp, index) => {
            if (mapp.parentID === payload.updateMerchantParent.parents) {
              umt.mapped.splice(index, 1);
            }
          });
        });
        const userfrndlymerchant = {};
        userfrndlymerchant.name = payload.updateMerchantParent.name;
        userfrndlymerchant.recordStatus = 0;
        userfrndlymerchant.id = payload.updateMerchantParent.parents;
        userfrndlymerchant.parent = null;
        state.unmappedMerchant.push(userfrndlymerchant);
        // }
      }
    },
    SET_MAPPED_UPDATE_MERCHANT(state, payload) {
      state.getMappedMerchants = payload;
      const mappingData = {};
      mappingData.parentID = payload.updateMerchant.parent.id;
      mappingData.merchantName = payload.updateMerchant.name;
      state.userFrndlyMerchants.forEach((umt) => {
        const mtData = {};
        mtData.id = umt.id;
        if (umt.id === payload.updateMerchant.parent.id) {
          if (umt.mapped) {
            umt.mapped.push(mappingData);
          }
        }
        state.unmappedMerchant.forEach((unmap, index) => {
          if (unmap.id === payload.updateMerchant.id) {
            state.unmappedMerchant.splice(index, 1);
          }
        });
      });
    },
    SET_UPDATE_MERCHANT(state, payload) {
      state.updateMerchantDetails = payload;
      if (payload.updateMerchantByTag.recordStatus === 1) {
        if (payload.updateMerchantByTag.parent === null) {
          const updateuserfrndly = state.userFrndlyMerchants.find((user) => user.id === payload.updateMerchantByTag.id);
          updateuserfrndly.name = payload.updateMerchantByTag.name;
        }
        const mappingData = {};
        if (payload.updateMerchantByTag.parent) {
          mappingData.parentID = payload.updateMerchantByTag.parent.id;
          mappingData.merchantName = payload.updateMerchantByTag.name;
          state.userFrndlyMerchants.forEach((umt) => {
            const mtData = {};
            mtData.id = umt.id;
            if (umt.id === payload.updateMerchantByTag.parent.id) {
              umt.mapped.push(mappingData);
            }
            state.unmappedMerchant.forEach((unmap, index) => {
              if (unmap.id === payload.updateMerchantByTag.id) {
                state.unmappedMerchant.splice(index, 1);
              }
            });
          });
        }
      }
    },
    SET_QBSYNC_UPDATED_STATUS(state, payload) {
      state.qbStatusUpdateForExpense = payload;
    },
    REMOVED_AUTO_MAP_RULES(state, payload) {
      state.removedMapRules = payload;
    },
    SET_AUTOMAP_RULES(state, payload) {
      state.autoMapRules = payload;
    },
    ADD_MERCHANT_CARD_DATA(state, payload) {
      state.addMerchantCard = payload;
    },
    REMOVE_MERCHANT_CARD_DATA(state, payload) {
      state.removeMerchantCard = payload;
    },
  },
  actions: {
    async uploadMerchantLogo({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      if (payload.logo !== '') {

        const AWS = require('aws-sdk');
        const BUCKET_NAME = process.env.VUE_APP_BUCKET_NAME;
        const IAM_USER_KEY = process.env.VUE_APP_AWS_IAM_USER_KEY;
        const IAM_USER_SECRET = process.env.VUE_APP_AWS_IAM_USER_SECRET;
        const s3bucket = new AWS.S3({
          accessKeyId: IAM_USER_KEY,
          secretAccessKey: IAM_USER_SECRET,
          Bucket: BUCKET_NAME,
        });

        const avatarName = `${payload.name.replace(/\s+/g, '-').toLowerCase()}`;
        let contentType = '';
        if (payload.logo.raw) {
          contentType = payload.logo.raw.type;
        } else {
          contentType = payload.logo.type;
        }
        const type = contentType.split('/').pop();
        const file = new File([payload.logo], `${avatarName}.${type}`);


        const acl = 'public-read';
        const newFileName = `${payload.logo.name}.${type}`;

        const usrIdObj = payload.id;
        const objkey = `${usrIdObj}/${newFileName}`;
        const contentDeposition = `inline;filename="${objkey}"`;

        s3bucket.createBucket(() => {
          const params = {
            Bucket: BUCKET_NAME,
            Key: objkey,
            Body: file,
            ContentDisposition: contentDeposition,
            ContentType: contentType,
            ACL: acl,
          };
          const Metadata = {
            'Content-Type': contentType,
            'Content-Disposition': contentDeposition,
            ACL: acl,
          };
          s3bucket.upload(params, async (err, data) => {
            if (err) {
              console.log(err);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            }
            payload.logo = data.Location;
            if (payload.id) {
              await apolloClient
                .mutate({
                  mutation: ADD_MERCHANT_LOGO_GQL,
                  variables: {
                    id: payload.id,
                    logo: payload.logo,
                  },
                })
                .then(({ data }) => {
                  commit('SET_MERCHANT_LOGO', data);
                  commit('shared/SET_LOADING', false, {
                    root: true,
                  });
                })
                .catch((err1) => {
                  console.log(err1);
                  commit('shared/SET_LOADING', false, {
                    root: true,
                  });
                });
            } else {
              await apolloClient
                .mutate({
                  mutation: CREATE_CUSTOM_MERCHANT_GQL,
                  variables: {
                    logo: payload.logo,
                    name: payload.name,
                    recordStatus: 1,
                  },
                  refetchQueries: () => [
                    {
                      query: GET_MAIN_MERCHANT_GQL,
                      variables: {
                        recordStatus: 1,
                        id: payload.id,
                      },
                    },
                    {
                      query: GET_MAPPED_MERCHANT,
                    },
                  ],
                })
                .then(({ data }) => {
                  commit('SET_NEW_MERCHANT', data);
                  commit('shared/SET_LOADING', false, {
                    root: true,
                  });
                })
                .catch((err1) => {
                  console.log(err1);
                  commit('shared/SET_LOADING', false, {
                    root: true,
                  });
                });
            }
          });
        });
      }
      if (payload.logo === '') {
        await apolloClient
          .mutate({
            mutation: CREATE_CUSTOM_MERCHANT_GQL,
            variables: {
              // logo: ,
              name: payload.name,
              recordStatus: 1,
            },
            refetchQueries: () => [
              {
                query: GET_MAIN_MERCHANT_GQL,
                variables: {
                  recordStatus: 1,
                  id: payload.id,
                },
              },
              {
                query: GET_MAPPED_MERCHANT,
              },
            ],
          })
          .then(({ data }) => {
            commit('SET_NEW_MERCHANT', data);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          })
          .catch((err1) => {
            console.log(err1);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          });
      }
    },
    async createCustomMerchant({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: CREATE_CUSTOM_MERCHANT_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
          refetchQueries: () => [
            {
              query: GET_MAIN_MERCHANT_GQL,
              variables: {
                recordStatus: 1,
                id: payload.id,
              },
            },
            {
              query: GET_MAPPED_MERCHANT,
            },
          ],
        })
        .then(({ data }) => {
          commit('SET_CREATED_MERCHANT', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },
    updateParentMerchants({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: UPDATE_MERCHANTS_PARENT_GQL,
          variables: payload,
          refetchQueries: () => [
            {
              query: GET_MAIN_MERCHANT_GQL,
              variables: {
                recordStatus: 1,
                id: payload.id,
              },
            },
            {
              query: GET_MAPPED_MERCHANT,
            },
          ],
        })
        .then(({ data }) => {
          apolloClient
            .query({
              query: GET_MERCHANT_QBSTATUS_TRANSACTIONS,
              variables: {
                month: payload.month,
                year: payload.year,
                merchantId: payload.merchantId,
              },
            }).then(({ data }) => {
              data.userExpensesByMerchant.forEach(merchntTrans => {
                if (merchntTrans.accountingTransaction !== null) {
                  apolloClient
                    .mutate({
                      mutation: UPDATE_QUICKBOOK_STATUS_FOR_MERCHANT_GQL,
                      variables: {
                        qbSyncStatus: 2,
                        qbSyncWhereStatus: 1,
                        merchantId: merchntTrans.accountingTransaction.id,
                      },
                    })
                    .then(({ data }) => {
                    });
                }
              });
            });

          data.updateMerchantParent.parents = payload.id;
          commit('SET_MERCHANT_PARENT', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },
    updateMappedMerchant({ commit }, payload) {
      apolloClient
        .mutate({
          mutation: UPDATE_CUSTOM_MERCHANT_GQL,
          variables: payload,
          refetchQueries: () => [
            {
              query: GET_MAIN_MERCHANT_GQL,
              variables: {
                recordStatus: 1,
                id: payload.id,
              },
            },
            {
              query: GET_MAPPED_MERCHANT,
            },
          ],
        })
        .then(({ data }) => {
          apolloClient
            .query({
              query: GET_MERCHANT_QBSTATUS_TRANSACTIONS,
              variables: {
                month: payload.month,
                year: payload.year,
                merchantId: payload.merchantId,
              },
            }).then(({ data }) => {
              data.userExpensesByMerchant.forEach(merchntTrans => {
                if (merchntTrans.accountingTransaction !== null) {
                  apolloClient
                    .mutate({
                      mutation: UPDATE_QUICKBOOK_STATUS_FOR_MERCHANT_GQL,
                      variables: {
                        qbSyncStatus: 2,
                        qbSyncWhereStatus: 1,
                        merchantId: merchntTrans.accountingTransaction.id,
                      },
                    })
                    .then(({ data }) => {

                    });
                }
              });
            });

          commit('SET_MAPPED_UPDATE_MERCHANT', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },
    updateMerchants({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: UPDATE_MERCHANT_TAG_GQL,
          variables: payload,
          refetchQueries: () => [
            {
              query: GET_MAIN_MERCHANT_GQL,
              variables: {
                recordStatus: 1,
                id: payload.id,
              },
            },
            {
              query: GET_MAPPED_MERCHANT,
            },
          ],
        })
        .then(({ data }) => {
          commit('SET_UPDATE_MERCHANT', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },

    getUserFriendlyMerchant({ commit }, payload) {
      commit('shared/SET_LOADING_CHILD', true, {
        root: true,
      });
      const promises = [];
      apolloClient
        .query({
          query: GET_MAIN_MERCHANT_GQL,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then(({ data }) => {
          const mrchnt = [];
          data.merchants.forEach(mchnts => {
            if (mchnts.recordStatus === 1 && mchnts.parent === null) {
              mrchnt.push(mchnts);
            }
          });
          const usrfrndly = data.merchants;
          const userFriendlyMerchantList = [];
          promises.push(
            apolloClient
              .query({
                query: GET_MAPPED_MERCHANT,
              })
              .then(({ data }) => {
                const mainMrchnt = [];
                data.merchants.forEach(usrfrndly => {
                  if ((usrfrndly.recordStatus === 1 || usrfrndly.recordStatus === 4) && usrfrndly.parent !== null) {
                    mainMrchnt.push(usrfrndly);
                  }
                });

                mrchnt.forEach((usrMerchant, index) => {
                  const merchntList = {};
                  merchntList.name = usrMerchant.name;
                  merchntList.logo = usrMerchant.logo;
                  merchntList.id = usrMerchant.id;
                  merchntList.index = index;
                  merchntList.mapped = [];
                  merchntList.autoMapRules = usrMerchant.autoMapRules;
                  mainMrchnt.forEach((mappdMerchant, index1) => {
                    if (mappdMerchant.parent !== null) {
                      if (usrMerchant.id === mappdMerchant.parent.id) {
                        const mappedData = {};
                        mappedData.parentID = mappdMerchant.id;
                        mappedData.merchantName = mappdMerchant.name;
                        mappedData.mIndex = index1;
                        mappedData.recordStatus = mappdMerchant.recordStatus;
                        merchntList.mapped.push(mappedData);
                      }
                    }
                  });
                  userFriendlyMerchantList.push(merchntList);
                });
              }),
          );
          Promise.all(promises).then(() => {
            commit('GET_USER_FRIENDLY_MERCHANTS', userFriendlyMerchantList);
            commit('shared/SET_LOADING_CHILD', false, {
              root: true,
            });
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
          console.log(err);
        });
    },
    getUnmappedMerchant({ commit }, payload) {
      commit('shared/SET_LOADING_CHILD', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_UNMAPPED_MERCHANT,
          variables: payload,
        })
        .then(({ data }) => {
          const unmappedList = [];
          data.merchants.forEach(mrchnt => {
            if (mrchnt.parent === null) {
              unmappedList.push(mrchnt);
            }
          });
          commit('SET_UNMAPPED_MERCHANT', unmappedList);
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
          console.log(err);
        });
    },
    getmappedMerchant({ commit }, payload) {
      commit('shared/SET_LOADING_CHILD', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_MAPPED_MERCHANT,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then(({ data }) => {
          const mrchntList = [];
          data.merchants.forEach(mchnt => {
            if (mchnt.parent !== null) {
              mrchntList.push(mchnt);
            }
          });
          commit('SET_MAPPED_MERCHANT', mrchntList);
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
          console.log(err);
        });
    },
    mappedMerchtDelete({ commit }, payload) {


      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: UPDATE_CUSTOM_MERCHANT_GQL,
          variables: payload,
        })
        .then(({ data }) => {

          commit('SET_QBSYNC_UPDATED_STATUS', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },
    UpdateQbSyncStatus({ commit }, payload) {
      apolloClient
        .mutate({
          mutation: UPDATE_QUICKBOOK_STATUS_FOR_MERCHANT_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_QBSYNC_UPDATED_STATUS', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },

    setAutoMapMerchant({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SET_AUTO_MAP_MERCHANT,
          variables: {
            ...payload,
            MerchantId: payload.MerchantId,
          },
        })
        .then(({ data }) => {
          commit('SET_AUTOMAP_RULES', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },

    addMerchantToCard({ commit }, payload) {

      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SET_MERCHANT_CARD,
          variables: {
            ...payload,
          },
        })
        .then(({ data }) => {
          commit('ADD_MERCHANT_CARD_DATA', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },

    removeMerchantToCard({ commit }, payload) {

      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: REMOVE_MERCHANT_CARD,
          variables: {
            ...payload,
          },
        })
        .then(({ data }) => {
          commit('REMOVE_MERCHANT_CARD_DATA', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },

    removeAutoMapRules({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: REMOVE_AUTO_MAP_MERCHANT,
          variables: {
            ...payload,
          },
        })
        .then(({ data }) => {

          commit('REMOVED_AUTO_MAP_RULES', data.removeAutoMapMerchant);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },

    getCardsMerchant({ commit }, payload) {

      apolloClient
        .query({
          query: GET_CARD_MERCHANT,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then(({ data }) => {
          // date: new Date(),
          if (data.getCardsMerchants) {
            commit('SET_CARD_MERCHANT', { data: data.getCardsMerchants.Merchant });
          }

          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },
  },
  getters: {
    merchantLogo: state => state.merchantLogo,
    userFrndlyMerchants: state => state.userFrndlyMerchants,
    createMerchants: state => state.createMerchants,
    updateMerchantDetails: state => state.updateMerchantDetails,
    unmappedMerchant: state => state.unmappedMerchant,
    mappedMerchants: state => state.mappedMerchants,
    getNewMerchant: state => state.getNewMerchant,
    qbStatusUpdateForExpense: state => state.qbStatusUpdateForExpense,
    getMappedMerchants: state => state.getMappedMerchants,
    autoMapRules: state => state.autoMapRules,
    removedMapRules: state => state.removedMapRules,
    updateMerchantParentDetails: state => state.updateMerchantParentDetails,
    addMerchantCard: state => state.addMerchantCard,
    removeMerchantCard: state => state.removeMerchantCard,
    cardsMerchant: state => state.cardsMerchant,
  },
};
